import React, { useEffect, useState } from "react";
import { getcargo } from "../api/cargoApi";
import CompanyCard from "../components/CompanyCard";

const CargoCompanies = () => {

  const [cargo, setCargo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 29;

  useEffect(() => {
    getcargo().then((res) => {
      setCargo(res.data);
    });
  }, []);

  // Pagination Logic
  const lastItemIndex = currentPage * itemsPerPage;
  const firstItemIndex = lastItemIndex - itemsPerPage;
  const currentcargo = cargo.slice(firstItemIndex, lastItemIndex);

  const totalPages = Math.ceil(cargo.length / itemsPerPage);

  return (
    <div className="container mt-5">
      <br /><br />
      <h3 className="text-center mb-5 section-title">Cargo Companies</h3>

      <div className="row">
        {currentcargo.map((company) => (
          <CompanyCard url="cargo" key={company.id} company={company} />
        ))} 
      </div>

      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center mt-4">

          {[...Array(totalPages)].map((_, index) => (
            <li
              key={index}
              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            </li>
          ))}

        </ul>
      </nav>

    </div>
  );
};

export default CargoCompanies;